import {
  APP_ROUTE_BASE,
  BENEFICIARY_TOKENIZATION,
  CARD_TOKENIZATION,
  SUBSCRIPTION,
  IDV,
  REUSABLE_LINK
} from 'routes/paths';

export const PREVIEW_POSSIBLE_VIEWS = {
  desktop: 'desktop',
  mobile: 'mobile',
  sdk: 'sdk'
};

export const PREVIEW_REDIRECT_URLS = {
  checkout: APP_ROUTE_BASE,
  card_tokenization: CARD_TOKENIZATION,
  beneficiary_tokenization: BENEFICIARY_TOKENIZATION,
  subscription: SUBSCRIPTION,
  idv: IDV,
  reusable_link: REUSABLE_LINK
};
